module.exports = __webpack_public_path__ + "img/stock6.b1bb8226.png";